export default {
    lang: {
        name: 'Last played'
    }
}